module.exports = __webpack_public_path__ + "img/2.d401fa87.svg";